import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import user from './modules/user';
import brands from './modules/brands';
import models from './modules/models';
import generations from './modules/generations';
import questions from './modules/questions';
import questionsGenerations from './modules/questionsGenerations';
import answers from './modules/answers';

export default new Vuex.Store({
  modules: {
    user,
    brands,
    models,
    generations,
    questions,
    questionsGenerations,
    answers
  },
  strict: process.env.NODE_ENV !== 'production'
});